import { NavigationSubItem } from './types';

const checkPath = (navLink: string, url: string) => {
  const isOnDashboard = navLink === '/' && url === '/';
  if (isOnDashboard) return true;
  return navLink !== '/' && url.indexOf(navLink) === 0;
};

export const getIsActive = (link: NavigationSubItem, url: string) => {
  const { location, additionalChildLocations: childRoutes } = link;
  let isActive = checkPath(location, url);

  if (!isActive && Array.isArray(childRoutes)) {
    for (const childLocation of childRoutes) {
      isActive = checkPath(childLocation, url);
      if (isActive) break;
    }
  }

  return isActive;
};
